import { IVec3, Vec3 } from "./Vec3";

export interface IRay3 {
  origin: IVec3;
  direction: IVec3;
  length?: number;
}

export class Ray3 {
  static fromPoints(from: IVec3, to: IVec3): IRay3 {
    const dir = Vec3.sub(to, from);
    const length = Vec3.len(dir);
    return {
      origin: from,
      direction: Vec3.mul(dir, 1 / length),
      length,
    };
  }

  static fromDir(origin: IVec3, dir: IVec3): IRay3 {
    const length = Vec3.len(dir);
    return {
      origin,
      direction: Vec3.mul(dir, 1 / length),
      length,
    };
  }


  static calcClosestPointOnRay(ray: IRay3, p: IVec3): { point: { x: number; y: number; z: number }; rayDistance: number } {
    const op = Vec3.sub(p, ray.origin);
    const rayDistance = Vec3.dot(op, ray.direction);

    return {
      point: Vec3.addScaled(ray.origin, ray.direction, rayDistance),
      rayDistance,
    };
  }

  static calcClosestPointOnTwoRays(rayA: IRay3, rayB: IRay3): [IVec3, IVec3] | undefined {
    const a = Vec3.dot(rayA.direction, rayA.direction);
    const b = Vec3.dot(rayA.direction, rayB.direction);
    const e = Vec3.dot(rayB.direction, rayB.direction);
    const d = a * e - b * b;
    if (d === 0) // parallel
      return undefined;

    const r = Vec3.sub(rayA.origin, rayB.origin);
    const c = Vec3.dot(rayA.direction, r);
    const f = Vec3.dot(rayB.direction, r);

    const s = (b * f - c * e) / d;
    const t = (a * f - c * b) / d;

    return [
      Vec3.addScaled(rayA.origin, rayA.direction, s),
      Vec3.addScaled(rayB.origin, rayB.direction, t)
    ]
  }
}
